import { createTracker } from 'usage-tracker';
import { TRACKER_NAME } from 'personalization-lib/constants/tracking/tracker';

// TODO: Remove this once we have usage tracking handled
export const tempUsageTracker = createTracker({
  standalone: true
});
export const getNormalizedTracker = tracker => {
  if (!tracker) {
    return null;
  }

  // Check if tracker is already standalone
  if ('standalone' in tracker) {
    return tracker.clone({
      standalone: true,
      trackerName: TRACKER_NAME
    });
  }

  // Convert legacy tracker to standalone for internal use
  return tracker.clone({
    standalone: true,
    preserveTrackerProperties: false,
    trackerName: TRACKER_NAME
  });
};